import { Box, Card, Grid } from '@mui/material';
import { Formik, FormikProps } from 'formik';
import React, {
  // useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { EICSRadioData, RoutingProps } from './IntakeClientsInfo';
import * as yup from 'yup';
import {
  getIntakeCurrentHealthInfoDetails,
  putIntakeCurrentHealthInfo,
} from '../../services/configApi/forms/Intake/IntakeServices';
import MediumTypography from '../../components/formlib/MediumTypography';
import CustomRadioButton from '../../components/formlib/CustomRadioButton';
import { IntakeRadioData } from './IntakePregnancyInfo';
import Textinput from '../../components/formlib/Textinput';
import { ReactComponent as DeleteIcon } from '../../assets/images/deleteAlertIcon.svg';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import CommentTextbox from '../../components/formlib/CommentTextbox';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import {
  HospitalInfoType,
  IntakeCurrentHealthInfoType,
  ResponseType,
} from '../../utils/type';
import { ApiError, isCustomError } from '../../services/ApiResponseHandler';
import DatePickerComponent from '../../components/formlib/DatePickerComponent';
import dayjs, { Dayjs } from 'dayjs';
import { formatPhoneNumber } from '../../utils/formValidationUtil';
import ModalPopup from '../../components/formlib/ModalPopup';
import { showCancelToaster } from './IntakeTabNavigationComponent';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';
import _ from 'lodash';
import { datePickerMinDateMaxDateValidate } from '../../utils/dateUtil';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import { useMultiplePermissions } from '../../hooks/usePermissions';
import { REFERRAL_STATUS_KEY } from '../../services/Constant';

const IntakeCurrentHealthInitialValues = {
  medication: {
    childHospitalizedFollowingBirth: '',
    hospitals: [
      {
        id: '',
        dateOfAdmitted: '',
        hospitalName: '',
        phoneNumber: '',
        comment: '',
      },
    ],
    immunizationsUpToDate: '',
    immunizationExplain: '',
    hearingScreening: '',
    hearingScreeningDesc: '',
    visionScreening: '',
    visionScreeningDesc: '',
    hearingVisionConcern: '',
  },
  healthIssue: {
    requireMedicalSupport: '',
    requireMedicalSupportDesc: '',
    medication: '',
    medicationDesc: '',
    privateServices: '',
    privateServicesDesc: '',
    childAsInfantDesc: '',
    childNowDesc: '',
  },
  doctor: {
    seenDentist: '',
    dentistFirstName: '',
    dentistLastName: '',
    dentistPhoneNumber: '',
    childOralHealth: '',
    childInjuries: '',
    childInjuriesDesc: '',
    childMedicalDiagnoses: '',
    childMedicalDiagnosesDesc: '',
  },
  childDesc: {
    childFavoriteActivityDesc: '',
    longTimeAttentionDesc: '',
    activityAvoidDesc: '',
    socialRelationship: '',
    socialRelationshipDesc: '',
    childEatingHabit: '',
    childEatingHabitDesc: '',
    childEatDesc: '',
    childFeedDesc: '',
    childGrowth: '',
    childGrowthDesc: '',
    childSleepHabit: '',
    childSleepHabitDesc: '',
    childSleepRoutineDesc: '',
  },
  eics: {
    childBloodLevel: '',
    childInsecureDifficulties: '',
    childNervousSystem: '',
    childMultipleTrauma: '',
    childDiagnosedAtBirth: '',
    childChronicFeeding: '',
    smallSize: '',
    childHospitalized: '',
    childChronicFeedingDesc: '',
    childInsecureDifficultiesDesc: '',
    childMultipleTraumaDesc: '',
  },
  isCurrentlyHeld: false,
  heldBy: '',
  isSigned: false,
  reviewdBy: '',
  reviewdDate: '',
  comment: '',
};

const validationSchema = yup.object().shape({
  hospitalization: yup.string().nullable(),
  hospitals: yup.array().of(
    yup
      .object()
      .shape({
        dateOfAdmitted: yup.string(),
        hospitalName: yup.string(),
        phoneNumber: yup.string(),
        comment: yup.string(),
      })
      .required()
      .nullable(),
  ),
  immunizationsUpToDate: yup.string().nullable(),
  immunizationExplain: yup.string().nullable(),
  seenDentist: yup.string().nullable(),
  dentistFirstName: yup.string().nullable(),
  dentistlastName: yup.string().nullable(),
  dentistPhoneNumber: yup.string().nullable(),
  childOralHealthExplain: yup.string().nullable(),
  seizureDisorderExplain: yup.string().nullable(),
  bloodLevel: yup.string().nullable(),
  bloodLevelDesc: yup.string().nullable(),
  heartDefectDesc: yup.string().nullable(),
  allergiesDesc: yup.string().nullable(),
  foodIntolerancesDesc: yup.string().nullable(),
  brokenBonesDesc: yup.string().nullable(),
  healthIssueOthers: yup.string().nullable(),
  medicalSpecialtyOther: yup.string().nullable(),
  medicalProcedureOther: yup.string().nullable(),
  therapies: yup.string().nullable(),
  theraphyDesc: yup.string().nullable(),
  temperamentDesc: yup.string().nullable(),
  childEatingDesc: yup.string().nullable(),
  childFeedDesc: yup.string().nullable(),
  childGrowthDesc: yup.string().nullable(),
  childSleepDesc: yup.string().nullable(),
  activitiesDesc: yup.string().nullable(),
  childBehaviourDesc: yup.string().nullable(),
  childActivities: yup.string().nullable(),
  socialRelationship: yup.string().nullable(),
  socialRelationshipDesc: yup.string().nullable(),
  childSmile: yup.string().nullable(),
  childRollOver: yup.string().nullable(),
  childCrawl: yup.string().nullable(),
  childWalkAlone: yup.string().nullable(),
  childSitIndependently: yup.string().nullable(),
  childImitateActions: yup.string().nullable(),
  childImitateSounds: yup.string().nullable(),
  childUseFirstWords: yup.string().nullable(),
  supportSystems: yup.string().nullable(),
  medicationExplain: yup.string().nullable(),
  childBloodLevel: yup.string().nullable(),
  childInsecureDifficulties: yup.string().nullable(),
  childNervousSystem: yup.string().nullable(),
  childMultipleTrauma: yup.string().nullable(),
  childHospitalized: yup.string().nullable(),
  childDiagnosedAtBirth: yup.string().nullable(),
  childChronicFeeding: yup.string().nullable(),
  smallSize: yup.string().nullable(),
});

interface UnsavedChangesWatcherProps {
  hasUnsavedChanges: boolean;
  onUnsavedChangesChange: (hasUnsavedChanges: boolean) => void;
}

const UnsavedChangesWatcher = ({
  hasUnsavedChanges,
  onUnsavedChangesChange,
}: UnsavedChangesWatcherProps) => {
  useLayoutEffect(() => {
    onUnsavedChangesChange(hasUnsavedChanges);
  }, [hasUnsavedChanges, onUnsavedChangesChange]);

  return null;
};

const IntakeCurrentHealthInfo: React.FC<RoutingProps> = ({ setTabProp }) => {
  const clientId = localStorage.getItem('ClientId');
  const [intakeCurrentHealthInfo, setIntakeCurrentHealthInfo] =
    useState<IntakeCurrentHealthInfoType>(IntakeCurrentHealthInitialValues);

  const [hospitalView, setHospitalView] = React.useState<HospitalInfoType[]>(
    IntakeCurrentHealthInitialValues.medication.hospitals,
  );

  const [intakeCurrentHealthSavedValues, setIntakeCurrentHealthSavedValues] =
    useState<IntakeCurrentHealthInfoType>();

  const formikRef = useRef<FormikProps<IntakeCurrentHealthInfoType>>(null);

  const { toggleLoader } = React.useContext(LoaderContext) as LoaderContextType;

  const [toastrDefaultMessage, setToastrDefaultMessage] = React.useState('');
  const [toastrId, setToastrId] = useState<string>();
  const [successOrError, setSuccessOrError] = useState<ResponseType>('success');

  const [openModal, setOpenModal] = useState(false);
  const parentRef = React.useRef<HTMLDivElement>(null);
  const permissions = useMultiplePermissions([
    'backend.clients',
    'backend.in_active_referrals',
  ]);
  const referralStatus = localStorage.getItem(REFERRAL_STATUS_KEY) ?? 'None';
  const [hasEditPermission, setHasEditPermission] = useState<boolean>(
    referralStatus === 'Inactive'
      ? permissions['backend.clients'].canEdit &&
          permissions['backend.in_active_referrals'].canEdit
      : permissions['backend.clients'].canEdit ||
          permissions['backend.in_active_referrals'].canEdit,
  );

  const { handleUpdateUnsavedChanges } = useContext(UnSavedChangesContext);

  useEffect(() => {
    if (!hasEditPermission) {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Tab') {
          e.preventDefault();
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [hasEditPermission]);

  useEffect(() => {
    const handleIntakeGet = async () => {
      handleIntakeGetAPI();
    };
    handleIntakeGet();
  }, []);

  const handleIntakeGetAPI = async () => {
    if (clientId) {
      window.scrollTo(0, 0);
      toggleLoader(true);
      getIntakeCurrentHealthInfoDetails(clientId)
        .then((response: IntakeCurrentHealthInfoType) => {
          if (response.isSigned) {
            setHasEditPermission(false);
          } else if (response.isCurrentlyHeld) {
            setHasEditPermission(false);
            showCancelToaster(response.heldBy);
          }
          setIntakeCurrentHealthSavedValues(response);

          setIntakeCurrentHealthInfo({
            ...intakeCurrentHealthInfo,
            medication: response.medication,
            childDesc: response.childDesc,
            doctor: response.doctor,
            healthIssue: response.healthIssue,
            eics: response.eics,
            comment: response.comment,
          });
          setHospitalView(response.medication.hospitals);

          setTimeout(() => {
            toggleLoader(false);
          }, 100);
        })
        .catch((error) => {
          toggleLoader(false);
          setSuccessOrError('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrId(error);
            setToastrDefaultMessage(error);
          }
        });
    }
  };

  const handleNameChange = (index: number, value: string) => {
    const nameChangeValue = [...hospitalView];
    nameChangeValue[index].hospitalName = value;
    setHospitalView(nameChangeValue);
  };

  const handlePhoneChange = (index: number, value: string) => {
    const phoneChangeValue = [...hospitalView];
    phoneChangeValue[index].phoneNumber = value;
    setHospitalView(phoneChangeValue);
  };

  const handleDateChange = (index: number, value: string | null) => {
    const dateChangeValue = [...hospitalView];
    dateChangeValue[index].dateOfAdmitted = value ?? '';
    setHospitalView(dateChangeValue);
  };

  const handleCommentChange = (index: number, value: string) => {
    const commentChangeValue = [...hospitalView];
    commentChangeValue[index].comment = value;
    setHospitalView(commentChangeValue);
  };

  const handleAddLink = () => {
    const updatedDataView = [...hospitalView];
    const newCode = {
      id: `${updatedDataView.length + 1}`,
      dateOfAdmitted: null,
      hospitalName: '',
      phoneNumber: '',
      comment: '',
    };

    updatedDataView.push(newCode);

    setHospitalView(updatedDataView);

    formikRef.current?.setValues({
      ...formikRef.current.values,
      medication: {
        ...formikRef.current.values.medication,
        hospitals: updatedDataView,
      },
    });
  };

  const handleFormSubmit = async (values: IntakeCurrentHealthInfoType) => {
    const params: IntakeCurrentHealthInfoType = {
      medication: {
        childHospitalizedFollowingBirth:
          values.medication.childHospitalizedFollowingBirth,
        hearingScreening: values.medication.hearingScreening,
        hearingScreeningDesc: values.medication.hearingScreeningDesc,
        hearingVisionConcern: values.medication.hearingVisionConcern,
        immunizationExplain: values.medication.immunizationExplain,
        immunizationsUpToDate: values.medication.immunizationsUpToDate,
        visionScreening: values.medication.visionScreening,
        visionScreeningDesc: values.medication.visionScreeningDesc,
        hospitals: hospitalView,
      },
      healthIssue: {
        childAsInfantDesc: values.healthIssue.childAsInfantDesc,
        childNowDesc: values.healthIssue.childNowDesc,
        medication: values.healthIssue.medication,
        medicationDesc: values.healthIssue.medicationDesc,
        privateServices: values.healthIssue.privateServices,
        privateServicesDesc: values.healthIssue.privateServicesDesc,
        requireMedicalSupport: values.healthIssue.requireMedicalSupport,
        requireMedicalSupportDesc: values.healthIssue.requireMedicalSupportDesc,
      },
      doctor: {
        childInjuries: values.doctor.childInjuries,
        childInjuriesDesc: values.doctor.childInjuriesDesc,
        childMedicalDiagnoses: values.doctor.childMedicalDiagnoses,
        childMedicalDiagnosesDesc: values.doctor.childMedicalDiagnosesDesc,
        childOralHealth: values.doctor.childOralHealth,
        dentistFirstName: values.doctor.dentistFirstName,
        dentistLastName: values.doctor.dentistLastName,
        dentistPhoneNumber: values.doctor.dentistPhoneNumber,
        seenDentist: values.doctor.seenDentist,
      },
      childDesc: {
        activityAvoidDesc: values.childDesc.activityAvoidDesc,
        childEatDesc: values.childDesc.childEatDesc,
        childEatingHabit: values.childDesc.childEatingHabit,
        childEatingHabitDesc: values.childDesc.childEatingHabitDesc,
        childFavoriteActivityDesc: values.childDesc.childFavoriteActivityDesc,
        childSleepHabit: values.childDesc.childSleepHabit,
        childSleepHabitDesc: values.childDesc.childSleepHabitDesc,
        childSleepRoutineDesc: values.childDesc.childSleepRoutineDesc,
        longTimeAttentionDesc: values.childDesc.longTimeAttentionDesc,
        socialRelationship: values.childDesc.socialRelationship,
        socialRelationshipDesc: values.childDesc.socialRelationshipDesc,
        childFeedDesc: values.childDesc.childFeedDesc,
        childGrowth: values.childDesc.childGrowth,
        childGrowthDesc: values.childDesc.childGrowthDesc,
      },
      eics: {
        childBloodLevel: values.eics.childBloodLevel,
        childChronicFeeding: values.eics.childChronicFeeding,
        childDiagnosedAtBirth: values.eics.childDiagnosedAtBirth,
        childHospitalized: values.eics.childHospitalized,
        childInsecureDifficulties: values.eics.childInsecureDifficulties,
        childMultipleTrauma: values.eics.childMultipleTrauma,
        childNervousSystem: values.eics.childNervousSystem,
        smallSize: values.eics.smallSize,
        childChronicFeedingDesc: values.eics.childChronicFeedingDesc,
        childInsecureDifficultiesDesc:
          values.eics.childInsecureDifficultiesDesc,
        childMultipleTraumaDesc: values.eics.childMultipleTraumaDesc,
      },
      heldBy: values.heldBy,
      comment: values.comment,
      isCurrentlyHeld: values.isCurrentlyHeld,
      isSigned: values.isSigned,
      reviewdBy: values.reviewdBy,
      reviewdDate: values.reviewdDate,
    };

    toggleLoader(true);

    if (clientId) {
      putIntakeCurrentHealthInfo(clientId, params)
        .then((response) => {
          if (response) {
            setSuccessOrError('success');
            setToastrId('Intake.successMsg');
            setToastrDefaultMessage('Intake updated successfully');

            setTimeout(() => {
              toggleLoader(false);
              setTabProp((value) => {
                sessionStorage.setItem(
                  'intakeTabName',
                  String(value.tabPosition),
                );
                return {
                  tabPosition: value.tabPosition,
                };
              });
            }, 1000);

            handleIntakeGetAPI();
          }
        })
        .catch((error) => {
          toggleLoader(false);
          setSuccessOrError('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrId(error);
            setToastrDefaultMessage(error);
          }
        });
    }
  };

  const handleCancellationFlow = () => {
    if (_.isEqual(intakeCurrentHealthInfo, formikRef.current?.values)) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      {toastrId && (
        <SnackBarComponent
          open={toastrId !== undefined}
          handleClose={() => {
            setToastrId(undefined);
          }}
          labelId={toastrId}
          defaultMessageId={toastrDefaultMessage}
          successOrError={successOrError}
          snackbarProps={{
            top: '60px !important',
          }}
        />
      )}
      <Box
        ref={parentRef}
        style={{
          pointerEvents: hasEditPermission ? 'auto' : 'none',
          opacity: hasEditPermission ? 'unset' : '0.8',
        }}
      >
        <Card className="formCardview gray3 borderRadius4 mb-md p-sm mt-md">
          <Formik
            initialValues={intakeCurrentHealthInfo}
            innerRef={formikRef}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleFormSubmit(values);
            }}
          >
            {({ values, setFieldValue }) => {
              return (
                <Box component="div">
                  <UnsavedChangesWatcher
                    hasUnsavedChanges={handleCancellationFlow()}
                    onUnsavedChangesChange={handleUpdateUnsavedChanges}
                  />
                  <Box
                    component="div"
                    className="p-sm gray3 borderRadius4"
                    sx={{
                      border: '1px solid #00C6B8',
                    }}
                  >
                    <MediumTypography
                      labelid="IntakeCurrentHealth.medical"
                      defaultlabel="Medical"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                    />
                    <MediumTypography
                      className="mr-xs mt-xs"
                      labelid="IntakeCurrentHealth.hospitalization"
                      defaultlabel="Has the child been hospitalized at any time following birth ?"
                    />

                    <CustomRadioButton
                      data={EICSRadioData}
                      value={values.medication.childHospitalizedFollowingBirth}
                      onSelectItem={(value) => {
                        if (value) {
                          if (
                            values.medication
                              .childHospitalizedFollowingBirth === 'No' ||
                            values.medication
                              .childHospitalizedFollowingBirth === 'Unknown'
                          ) {
                            setFieldValue('hospitals', []);
                            setFieldValue('medication.hospitals', []);
                            setHospitalView([]);
                          }
                          setFieldValue(
                            'medication.childHospitalizedFollowingBirth',
                            value,
                          );
                        }
                      }}
                    />
                    {values.medication.childHospitalizedFollowingBirth ===
                      'Yes' && (
                      <Box>
                        {hospitalView.map(
                          (items: HospitalInfoType, i: number) => (
                            <Grid
                              item
                              container
                              rowSpacing={'12px'}
                              columnSpacing={'40px'}
                              sx={{ display: 'flex' }}
                              className="pt-md"
                              key={items.id}
                            >
                              <Grid item xs={3}>
                                <Textinput
                                  name={`hospitalName${i}`}
                                  labelid="IntakeCurrentHealth.hospitalName"
                                  defaultlabelid="Hospital Name"
                                  sxProps={{
                                    background: 'rgba(255, 255, 255, 1)',
                                  }}
                                  Value={
                                    values.medication.hospitals[i]?.hospitalName
                                  }
                                  handlechange={(value: string) => {
                                    setFieldValue(
                                      `medication.hospitals[${i}].hospitalName`,
                                      value,
                                    );
                                    handleNameChange(i, value);
                                  }}
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                              </Grid>
                              <Grid item xs={3}>
                                <Textinput
                                  name={`phoneNumber${i}`}
                                  labelid="cType1"
                                  defaultlabelid="Phone"
                                  sxProps={{
                                    background: 'rgba(255, 255, 255, 1)',
                                  }}
                                  inputProps={{
                                    maxLength: 12,
                                    pattren: ['0-9'],
                                  }}
                                  Value={
                                    values.medication.hospitals[i]?.phoneNumber
                                  }
                                  handlechange={(value: string) => {
                                    const validatedNumber =
                                      formatPhoneNumber(value);
                                    setFieldValue(
                                      `medication.hospitals[${i}].phoneNumber`,
                                      validatedNumber,
                                    );
                                    handlePhoneChange(i, value);
                                  }}
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                              </Grid>
                              <Grid item xs={3}>
                                <DatePickerComponent
                                  className="bg__white"
                                  value={dayjs(
                                    values.medication.hospitals[i]
                                      ?.dateOfAdmitted,
                                  )}
                                  disableFuture={false}
                                  labelid="intake.dateOfAdmitted"
                                  defaultlabelid="Date Of Admitted"
                                  handlechange={(date: Dayjs | null) => {
                                    const formattedDate =
                                      dayjs(date).format('MM/DD/YYYY');
                                    if (date === null) {
                                      setFieldValue(
                                        `medication.hospitals[${i}].dateOfAdmitted`,
                                        null,
                                      );
                                      handleDateChange(i, null);
                                    } else {
                                      setFieldValue(
                                        `medication.hospitals[${i}].dateOfAdmitted`,
                                        formattedDate,
                                      );
                                      handleDateChange(i, formattedDate);
                                    }
                                  }}
                                />
                                {datePickerMinDateMaxDateValidate(
                                  items.dateOfAdmitted,
                                ) && (
                                  <MediumTypography
                                    labelid={'datePickerMinDateMaxDateValidate'}
                                    defaultlabel="Enter a date between 01/01/1900 and 01/01/2100"
                                    className="errorText-md"
                                  />
                                )}
                              </Grid>

                              <Grid item xs={9}>
                                <Textinput
                                  name={`comment${i}`}
                                  labelid="myTimeOffReason"
                                  defaultlabelid="Reason"
                                  sxProps={{
                                    background: 'rgba(255, 255, 255, 1)',
                                  }}
                                  Value={
                                    values.medication.hospitals[i]?.comment
                                  }
                                  handlechange={(value: string) => {
                                    setFieldValue(
                                      `medication.hospitals[${i}].comment`,
                                      value,
                                    );
                                    handleCommentChange(i, value);
                                  }}
                                  inputProps={{
                                    maxLength: 100,
                                  }}
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                              </Grid>
                              <Grid item xs={0.5}>
                                {i >= 0 && (
                                  <DeleteIcon
                                    style={{
                                      position: 'relative',
                                      cursor: 'pointer',
                                      width: '22px',
                                      height: '22px',
                                      top: '5px',
                                      right: '30px',
                                    }}
                                    onClick={() => {
                                      const updatedSubCategories = [
                                        ...hospitalView,
                                      ];
                                      updatedSubCategories.splice(i, 1);
                                      formikRef.current?.setValues({
                                        ...formikRef.current?.values,
                                        medication: {
                                          ...formikRef.current?.values
                                            .medication,
                                          hospitals: updatedSubCategories,
                                        },
                                      });
                                      setHospitalView(updatedSubCategories);
                                    }}
                                  />
                                )}
                              </Grid>
                            </Grid>
                          ),
                        )}

                        {values.medication.hospitals.length < 3 && (
                          <Grid item xs={4.5}>
                            <ButtonComponent
                              className="btn-add-code pt-md"
                              variantType="contained"
                              type="submit"
                              labelId="IntakeCurrentHealth.addhospitalName"
                              defaultLabelId="+ Add Hospital"
                              onClick={handleAddLink}
                            />
                          </Grid>
                        )}
                      </Box>
                    )}
                    <Box component="div" className="align__items__center mt-md">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakePregnancy.childHospitalized"
                          defaultlabel="Was the child hospitalized for more than 25 days during a 6-month period, excluding the initial birth admission to a NICU ?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.childHospitalized}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.childHospitalized', value);
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-md">
                      <MediumTypography
                        className="mr-md"
                        labelid="IntakeCurrentHealth.ImmunizationsUpToDate"
                        defaultlabel="Are this child’s immunizations up to date?"
                      />
                      <CustomRadioButton
                        data={IntakeRadioData}
                        value={values.medication.immunizationsUpToDate}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue(
                              'medication.immunizationsUpToDate',
                              value,
                            );
                            setFieldValue('medication.immunizationExplain', '');
                          }
                        }}
                      />
                    </Box>
                    {values.medication.immunizationsUpToDate === 'No' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.medication.immunizationExplain}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue(
                                'medication.immunizationExplain',
                                e,
                              );
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-md">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeCurrentHealth.smallSize"
                          defaultlabel="Is child's weight, weight for height, or height for age less than the 5th percentile (Small size)?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.smallSize}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.smallSize', value);
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-md">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeCurrentHealth.childBloodLevel"
                          defaultlabel="Blood lead levels measured 5 micrograms/dl?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.childBloodLevel}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.childBloodLevel', value);
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.childHearing"
                        defaultlabel="Has this child had any other hearing evaluations besides the newborn hearing screening?"
                        className="mr-md"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.medication.hearingScreening}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('medication.hearingScreening', value);
                            setFieldValue(
                              'medication.hearingScreeningDesc',
                              '',
                            );
                          }
                        }}
                      />
                    </Box>
                    {values.medication.hearingScreening === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.medication.hearingScreeningDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue(
                                'medication.hearingScreeningDesc',
                                e,
                              );
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.childVision"
                        defaultlabel="Has this child had any vision screenings?"
                        className="mr-md"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.medication.visionScreening}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('medication.visionScreening', value);
                            setFieldValue('medication.visionScreeningDesc', '');
                          }
                        }}
                      />
                    </Box>
                    {values.medication.visionScreening === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.medication.visionScreeningDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue(
                                'medication.visionScreeningDesc',
                                e,
                              );
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box display="flex" flexDirection="row" className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.hearingOrVisionConcerns"
                        defaultlabel="Do you have any hearing or vision concerns for this child ?"
                        className="mr-md"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'40px'}
                      className="mt-md mb-lg"
                    >
                      {' '}
                      <Grid item xs={9} lg={9}>
                        <CommentTextbox
                          Value={values.medication.hearingVisionConcern}
                          placeholder="Comments"
                          name="immunizationExplain"
                          maxLength={2000}
                          handlechange={(e) => {
                            setFieldValue('medication.hearingVisionConcern', e);
                          }}
                          rows={4}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                    <Box className="mt-sm">
                      <MediumTypography
                        className="mr-lg"
                        labelid="IntakeCurrentHealth.seenDentist"
                        defaultlabel="Has this child seen a dentist?"
                      />
                      <CustomRadioButton
                        data={IntakeRadioData}
                        value={values.doctor.seenDentist}
                        onSelectItem={(value) => {
                          if (value) {
                            if (value === 'No') {
                              setFieldValue('doctor.dentistFirstName', '');
                              setFieldValue('doctor.dentistlastName', '');
                              setFieldValue('doctor.dentistPhoneNumber', '');
                            }
                            setFieldValue('doctor.seenDentist', value);
                          }
                        }}
                      />
                    </Box>
                    {values.doctor.seenDentist === 'Yes' && (
                      <Grid
                        item
                        container
                        rowSpacing={'24px'}
                        columnSpacing={'40px'}
                        sx={{ display: 'flex' }}
                        className="pt-md"
                      >
                        <Grid item xs={3}>
                          <Textinput
                            name="dentistFirstName"
                            labelid="IntakeCurrentHealth.dentistFirstName"
                            defaultlabelid="First Name"
                            Value={values.doctor.dentistFirstName}
                            handlechange={(text: string) => {
                              setFieldValue(
                                'doctor.dentistFirstName',
                                text.replace(/[^A-Za-z,'. -]/g, ''),
                              );
                            }}
                            sxProps={{
                              backgroundColor: 'white',
                            }}
                            placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <Textinput
                            name="dentistlastName"
                            labelid="IntakeCurrentHealth.dentistlastName"
                            defaultlabelid="Last Name"
                            Value={values.doctor.dentistLastName}
                            handlechange={(text: string) => {
                              setFieldValue(
                                'doctor.dentistLastName',
                                text.replace(/[^A-Za-z,'. -]/g, ''),
                              );
                            }}
                            sxProps={{
                              backgroundColor: 'white',
                            }}
                            placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <Textinput
                            name="dentistPhoneNumber"
                            labelid="IntakeCurrentHealth.dentistPhoneNumber"
                            defaultlabelid="Phone Number"
                            Value={values.doctor.dentistPhoneNumber}
                            handlechange={(text: string) => {
                              const validatedNumber = formatPhoneNumber(text);
                              setFieldValue(
                                'doctor.dentistPhoneNumber',
                                validatedNumber,
                              );
                            }}
                            inputProps={{
                              maxLength: 12,
                              pattren: ['0-9'],
                            }}
                            sxProps={{
                              backgroundColor: 'white',
                            }}
                            placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box display="flex" flexDirection="row" className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.oralHealthOrTeeth"
                        defaultlabel="Do you or the dentist have any concerns about this child’s oral health or teeth ?"
                        className="mr-md"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'40px'}
                      className="mt-md mb-lg"
                    >
                      {' '}
                      <Grid item xs={9} lg={9}>
                        <CommentTextbox
                          Value={values.doctor.childOralHealth}
                          placeholder="Comments"
                          name="immunizationExplain"
                          maxLength={2000}
                          handlechange={(e) => {
                            setFieldValue('doctor.childOralHealth', e);
                          }}
                          rows={4}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.anySignificantAccidentsOrInjuries"
                        defaultlabel="Has this child experienced any significant accidents or injuries ?"
                        className="mr-md"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.doctor.childInjuries}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('doctor.childInjuries', value);
                            setFieldValue('doctor.childInjuriesDesc', '');
                          }
                        }}
                      />
                    </Box>
                    {values.doctor.childInjuries === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.doctor.childInjuriesDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue('doctor.childInjuriesDesc', e);
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.anyMedicalDiagnosesOrChronicHealthConditions"
                        defaultlabel="Does this child have any medical diagnoses or chronic health conditions ?"
                        className="mr-md"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.doctor.childMedicalDiagnoses}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue(
                              'doctor.childMedicalDiagnoses',
                              value,
                            );
                            setFieldValue(
                              'doctor.childMedicalDiagnosesDesc',
                              '',
                            );
                          }
                        }}
                      />
                    </Box>
                    {values.doctor.childMedicalDiagnoses === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.doctor.childMedicalDiagnosesDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue(
                                'doctor.childMedicalDiagnosesDesc',
                                e,
                              );
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-md">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeCurrentHealth.childNervousSystem"
                          defaultlabel="Suspected central nervous system abnormality ?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.childNervousSystem}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.childNervousSystem', value);
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.anyMedicalSupportsEquipmentOrServices"
                        defaultlabel="Does this child currently require any medical supports, equipment, or services ?"
                        className="mr-md"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.healthIssue.requireMedicalSupport}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue(
                              'healthIssue.requireMedicalSupport',
                              value,
                            );
                            setFieldValue(
                              'healthIssue.requireMedicalSupportDesc',
                              '',
                            );
                          }
                        }}
                      />
                    </Box>
                    {values.healthIssue.requireMedicalSupport === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.healthIssue.requireMedicalSupportDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue(
                                'healthIssue.requireMedicalSupportDesc',
                                e,
                              );
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.anyMedication"
                        defaultlabel="Is this child currently taking any medication ?"
                        className="mr-md"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.healthIssue.medication}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('healthIssue.medication', value);
                            setFieldValue('healthIssue.medicationDesc', '');
                          }
                        }}
                      />
                    </Box>
                    {values.healthIssue.medication === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.healthIssue.medicationDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue('healthIssue.medicationDesc', e);
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.anyPrivateServicesOrTherapies"
                        defaultlabel="Is this child receiving any private services or therapies ?"
                        className="mr-md"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.healthIssue.privateServices}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('healthIssue.privateServices', value);
                            setFieldValue(
                              'healthIssue.privateServicesDesc',
                              '',
                            );
                          }
                        }}
                      />
                    </Box>
                    {values.healthIssue.privateServices === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.healthIssue.privateServicesDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue(
                                'healthIssue.privateServicesDesc',
                                e,
                              );
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <MediumTypography
                      labelid="IntakeCurrentHealth.temperamentBehaviorActivityPreferencesSocialSkills"
                      defaultlabel="Temperament, Behavior, Activity Preferences, Social Skills"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="mt-sm"
                    />
                    <Box display="flex" flexDirection="row" className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.howWouldYouDescribeThisChildAsAnInfant"
                        defaultlabel="How would you describe this child as an infant? (Examples: temperament, personality, responsiveness, fussy, quiet, colicky, sleepy, etc.)"
                        className="mr-md"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'40px'}
                      className="mt-md mb-lg"
                    >
                      {' '}
                      <Grid item xs={9} lg={9}>
                        <CommentTextbox
                          Value={values.healthIssue.childAsInfantDesc}
                          placeholder="Comments"
                          name="immunizationExplain"
                          maxLength={2000}
                          handlechange={(e) => {
                            setFieldValue('healthIssue.childAsInfantDesc', e);
                          }}
                          rows={4}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                    <Box display="flex" flexDirection="row" className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.howWouldYouDescribeThisChildNow"
                        defaultlabel="How would you describe this child now? (Examples: personality, interactiveness, behavior or discipline concerns) "
                        className="mr-md"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'40px'}
                      className="mt-md mb-lg"
                    >
                      {' '}
                      <Grid item xs={9} lg={9}>
                        <CommentTextbox
                          Value={values.healthIssue.childNowDesc}
                          placeholder="Comments"
                          name="immunizationExplain"
                          maxLength={2000}
                          handlechange={(e) => {
                            setFieldValue('healthIssue.childNowDesc', e);
                          }}
                          rows={4}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                    <Box display="flex" flexDirection="row" className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.pleaseDescribeThisChildsFavoriteActivities"
                        defaultlabel="Please describe this child’s favorite activities."
                        className="mr-md"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'40px'}
                      className="mt-md mb-lg"
                    >
                      {' '}
                      <Grid item xs={9} lg={9}>
                        <CommentTextbox
                          Value={values.childDesc.childFavoriteActivityDesc}
                          placeholder="Comments"
                          name="immunizationExplain"
                          maxLength={2000}
                          handlechange={(e) => {
                            setFieldValue(
                              'childDesc.childFavoriteActivityDesc',
                              e,
                            );
                          }}
                          rows={4}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                    <Box display="flex" flexDirection="row" className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.whatActivitiesKeepTheirAttentionForTheLongestTime"
                        defaultlabel="What activities keep their attention for the longest time?"
                        className="mr-md"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'40px'}
                      className="mt-md mb-lg"
                    >
                      {' '}
                      <Grid item xs={9} lg={9}>
                        <CommentTextbox
                          Value={values.childDesc.longTimeAttentionDesc}
                          placeholder="Comments"
                          name="immunizationExplain"
                          maxLength={2000}
                          handlechange={(e) => {
                            setFieldValue('childDesc.longTimeAttentionDesc', e);
                          }}
                          rows={4}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                    <Box display="flex" flexDirection="row" className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.anyActivitiesThisChildDoesNotEnjoyOrAvoids"
                        defaultlabel="Please describe any activities that this child does not enjoy or avoids."
                        className="mr-md"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'40px'}
                      className="mt-md mb-lg"
                    >
                      {' '}
                      <Grid item xs={9} lg={9}>
                        <CommentTextbox
                          Value={values.childDesc.activityAvoidDesc}
                          placeholder="Comments"
                          name="immunizationExplain"
                          maxLength={2000}
                          handlechange={(e) => {
                            setFieldValue('childDesc.activityAvoidDesc', e);
                          }}
                          rows={4}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.childHasDifficultyWithSocialRelationships"
                        defaultlabel="Do you feel this child has difficulty with social relationships ?"
                        className="mr-md"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.childDesc.socialRelationship}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue(
                              'childDesc.socialRelationship',
                              value,
                            );
                            setFieldValue(
                              'childDesc.socialRelationshipDesc',
                              '',
                            );
                          }
                        }}
                      />
                    </Box>
                    {values.childDesc.socialRelationship === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.childDesc.socialRelationshipDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue(
                                'childDesc.socialRelationshipDesc',
                                e,
                              );
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-md">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeCurrentHealth.childInsecureDifficulties"
                          defaultlabel="Difficulty with insecure attachment/interactional difficulties ?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.childInsecureDifficulties}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue(
                              'eics.childInsecureDifficulties',
                              value,
                            );
                            setFieldValue(
                              'eics.childInsecureDifficultiesDesc',
                              '',
                            );
                          }
                        }}
                      />
                    </Box>
                    {values.eics.childInsecureDifficulties === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.eics.childInsecureDifficultiesDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue(
                                'eics.childInsecureDifficultiesDesc',
                                e,
                              );
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-md">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeCurrentHealth.childMultipleTrauma"
                          defaultlabel="Multiple trauma/losses experienced by child ?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.childMultipleTrauma}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.childMultipleTrauma', value);
                            setFieldValue('eics.childMultipleTraumaDesc', '');
                          }
                        }}
                      />
                    </Box>
                    {values.eics.childMultipleTrauma === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.eics.childMultipleTraumaDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue('eics.childMultipleTraumaDesc', e);
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <MediumTypography
                      labelid="IntakeCurrentHealth.eatingSleeping"
                      defaultlabel="Eating, Sleeping"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="mt-sm"
                    />
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.concernsEatingHabits"
                        defaultlabel="Do you have any concerns about the child’s eating habits ?"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.childDesc.childEatingHabit}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('childDesc.childEatingHabit', value);
                            setFieldValue('childDesc.childEatingHabitDesc', '');
                          }
                        }}
                      />
                    </Box>
                    {values.childDesc.childEatingHabit === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.childDesc.childEatingHabitDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue(
                                'childDesc.childEatingHabitDesc',
                                e,
                              );
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box display="flex" flexDirection="row" className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.childEatingFoods"
                        defaultlabel="What foods does this child eat ?"
                        className="mr-md"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'40px'}
                      className="mt-md mb-lg"
                    >
                      {' '}
                      <Grid item xs={9} lg={9}>
                        <CommentTextbox
                          Value={values.childDesc.childEatDesc}
                          placeholder="Comments"
                          name="immunizationExplain"
                          maxLength={2000}
                          handlechange={(e) => {
                            setFieldValue('childDesc.childEatDesc', e);
                          }}
                          rows={4}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                    <Box display="flex" flexDirection="row" className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.childFeedThenSelf"
                        defaultlabel="How does this child feed themself ?"
                        className="mr-md"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'40px'}
                      className="mt-md mb-lg"
                    >
                      {' '}
                      <Grid item xs={9} lg={9}>
                        <CommentTextbox
                          Value={values.childDesc.childFeedDesc}
                          placeholder="Comments"
                          name="immunizationExplain"
                          maxLength={2000}
                          handlechange={(e) => {
                            setFieldValue('childDesc.childFeedDesc', e);
                          }}
                          rows={4}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.concernsNutritionGrowth"
                        defaultlabel="Do you have any concerns about this child’s nutrition or growth ?"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.childDesc.childGrowth}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('childDesc.childGrowth', value);
                            setFieldValue('childDesc.childGrowthDesc', '');
                          }
                        }}
                      />
                    </Box>
                    {values.childDesc.childGrowth === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.childDesc.childGrowthDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue('childDesc.childGrowthDesc', e);
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-md">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeCurrentHealth.childChronicFeeding"
                          defaultlabel="Chronic feeding difficulties ? *"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.childChronicFeeding}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.childChronicFeeding', value);
                            setFieldValue('eics.childChronicFeedingDesc', '');
                          }
                        }}
                      />
                    </Box>
                    {values.eics.childChronicFeeding === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.eics.childChronicFeedingDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue('eics.childChronicFeedingDesc', e);
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.childSleepHabits"
                        defaultlabel="Do you have any concerns about the child’s sleep habits ?"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.childDesc.childSleepHabit}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('childDesc.childSleepHabit', value);
                            setFieldValue('childDesc.childSleepHabitDesc', '');
                          }
                        }}
                      />
                    </Box>
                    {values.childDesc.childSleepHabit === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.childDesc.childSleepHabitDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue('childDesc.childSleepHabitDesc', e);
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-md">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.childSleepRoutine"
                        defaultlabel="Please describe this child’s current sleep routine."
                      />
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.childDesc.childSleepRoutineDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            handlechange={(e) => {
                              setFieldValue(
                                'childDesc.childSleepRoutineDesc',
                                e,
                              );
                            }}
                            rows={4}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    </Box>

                    <Box className="mt-md">
                      <MediumTypography
                        labelid="Intake.additionalCommentsTitle"
                        defaultlabel="Additional Comments"
                        fontSize="16px"
                        fontweight={600}
                        textColor="#2A4241"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'40px'}
                      className="mt-md mb-lg"
                    >
                      <Grid item xs={9} lg={9}>
                        <CommentTextbox
                          Value={values.comment}
                          placeholder="Comments"
                          name="comment"
                          maxLength={3000}
                          handlechange={(e) => {
                            setFieldValue('comment', e);
                          }}
                          rows={4}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <ModalPopup
                    description="formUnsavedChangesMessage"
                    open={openModal}
                    onCancel={() => {
                      setOpenModal(false);
                    }}
                    onOk={() => {
                      formikRef.current?.resetForm();
                      setIntakeCurrentHealthInfo({
                        ...intakeCurrentHealthInfo,
                      });

                      setHospitalView(
                        intakeCurrentHealthSavedValues?.medication.hospitals ||
                          [],
                      );
                      setOpenModal(false);
                    }}
                    labelId1="Clientpage.Nobtn"
                    negativeActionLabel="No"
                    labelId2="Clientpage.Yesbtn"
                    positiveActionLabel="Yes"
                  />
                </Box>
              );
            }}
          </Formik>
        </Card>

        <Box
          className="mt-md mb-xlg"
          display={'flex'}
          justifyContent={'flex-end'}
        >
          <ButtonComponent
            className="btn-primary btn-cancel alrt_Width_btn mr-md"
            variantType="contained"
            labelId={'cancelText'}
            defaultLabelId={'Cancel'}
            sxProps={{
              display: hasEditPermission ? 'auto' : 'none',
            }}
            onClick={() =>
              handleCancellationFlow()
                ? setOpenModal(true)
                : setOpenModal(false)
            }
          />

          <ButtonComponent
            variantType="contained"
            type="submit"
            className="btn-primary btn-submit alrt_Width_btn"
            labelId={'Intake.submit'}
            defaultLabelId={'Save'}
            sxProps={{
              display: hasEditPermission ? 'auto' : 'none',
            }}
            onClick={() => {
              const isDateInRange =
                formikRef.current?.values.medication.hospitals.every((val) => {
                  return !datePickerMinDateMaxDateValidate(val.dateOfAdmitted);
                });

              if (!isDateInRange) {
                setSuccessOrError('error');
                setToastrId('datePickerMinDateMaxDateValidate');
                setToastrDefaultMessage(
                  'Enter a date between 01/01/1900 and 01/01/2100',
                );
              } else {
                formikRef.current?.handleSubmit();
              }
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default IntakeCurrentHealthInfo;
